import React, { useState } from "react";
import PropTypes from "prop-types";
import EditIcon from "assets/images/form/edit-icon.svg";
import DeactivateIcon from "assets/images/form/deactivate-icon.svg";
import ActivateIcon from "assets/images/form/activate-icon.png";
import DetailIcon from "assets/images/form/detail-view.svg";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import GridViewActionImage from "assets/images/general/grid-view-action.svg";
import { getUserRole } from "recoil/Auth";
import OutsideClickHandler from "react-outside-click-handler";

function CourseActions({ data, props, viewType }) {
  const userRole = useRecoilValue(getUserRole);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const editCourse = () => {
    if (data.is_active)
      navigate("/edit_course", { state: { update_id: data.id } });
    else props.actionOnDeactivatedCourse();
  };
  const viewCourseDetail = () => {
    if (data.is_active)
      navigate("/course_detail", { state: { record_id: data.id } });
    else props.actionOnDeactivatedCourse();
  };
  const viewCourseModuleUnitsList = () => {
    if (data.is_active)
      navigate("/course_modules", { state: { record_id: data.id } });
    else props.actionOnDeactivatedCourse();
  };
  const deleteCourse = async () => {
    props.deactivateCourseConfirmation(data.id, data.is_active);
  };

  return (
    <div className="d-flex gap-3 table-actions">
      {viewType === "grid" ? (
        <>
          <OutsideClickHandler
            onOutsideClick={() => {
              setShowMenu(false);
            }}
          >
            <div className="position-relative">
              <img
                src={GridViewActionImage}
                alt="action"
                className="cursor-pointer"
                onClick={() => setShowMenu(!showMenu)}
              />
              {showMenu ? (
                <div className="actions-list">
                  {userRole === "STUDENT" || userRole === "TEACHER" ? (
                    <span onClick={viewCourseDetail}>View Details</span>
                  ) : userRole === "BUSINESS_ADMIN" ? (
                    <>
                      <span onClick={viewCourseDetail}>View Details</span>
                      <span onClick={editCourse}>Edit</span>
                      <span onClick={deleteCourse}>
                        {data.is_active ? "Deactivate" : "Activate"}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          </OutsideClickHandler>
        </>
      ) : viewType === "list" ? (
        userRole === "SUPER_ADMIN" ? (
          <span onClick={viewCourseModuleUnitsList}>View Modules & Units</span>
        ) : userRole === "STUDENT" || userRole === "TEACHER" ? (
          <img onClick={viewCourseDetail} src={DetailIcon} alt="edit-icon" />
        ) : userRole === "BUSINESS_ADMIN" ? (
          <>
            <img onClick={viewCourseDetail} src={DetailIcon} alt="edit-icon" />
            <img onClick={editCourse} src={EditIcon} alt="edit-icon" />
            <img
              onClick={deleteCourse}
              src={data.is_active ? DeactivateIcon : ActivateIcon}
              alt="edit-icon"
            />
          </>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </div>
  );
}
CourseActions.propTypes = {
  data: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired,
};
export default CourseActions;
